document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.copy-clip').forEach(function(el) {
        const icon = el.querySelector('.copy-icon');
        let timeout;
        el.addEventListener('mouseenter', function() {
            el.style.background = '#f8f9fa';
        });
        el.addEventListener('mouseleave', function() {
            el.style.background = '';
            // Regresa el icono a copiar si estaba en check
            if (icon) {
                icon.classList.remove('fa-check', 'fa-solid');
                icon.classList.add('fa-copy', 'fa-regular');
            }
            if (timeout) clearTimeout(timeout);
        });
        el.addEventListener('click', function(e) {
            e.preventDefault();
            const text = el.getAttribute('data-copy');
            if (text) {
                navigator.clipboard.writeText(text).then(function() {
                    // Cambia el icono a check
                    if (icon) {
                        icon.classList.remove('fa-copy', 'fa-regular');
                        icon.classList.add('fa-check', 'fa-solid');
                    }
                    // Regresa el icono después de 1.2s
                    timeout = setTimeout(function() {
                        if (icon) {
                            icon.classList.remove('fa-check', 'fa-solid');
                            icon.classList.add('fa-copy', 'fa-regular');
                        }
                    }, 1200);
                });
            }
        });
        // Para accesibilidad: copiar con Enter o Space
        el.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                el.click();
            }
        });
        el.style.position = 'relative';
    });
});